import { useLazyQuery, useMutation } from "@apollo/client/react";import React, { useEffect, useState } from 'react';
import 'moment/locale/es';
import { useLocation, useNavigate } from 'react-router-dom';
import { FormControl, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { TextInput } from '../../../components/textInput/TextInput';
import toast from 'react-hot-toast';
import { GET_JUSTIFICACION_MOTIVO } from '../../../data/graphQL/queries/AdminBloqueo/getJustificacionMotivo';
import { UPDATE_JUSTIFICACION_CONDICIONAL } from '../../../data/graphQL/mutations/AdminBloqueo/UpdateJustificacion';
import { GET_APP_PERMISSION_BY_NOMBRE } from '../../../data/graphQL/queries/Utils/queries';

import { CustomButton } from '../../../components/customButton/CustomButton';

export const JustificacionBloqueo = ({ setChildrenAction }) => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { justificacion } = state;
  const [selectAreaDisabled, setSelectAreaDisabled] = useState(true);
  const [selectEstadoDisabled, setSelectEstadoDisabled] = useState(true);
  const [selectJustificacionDisabled, setSelectJustificacionDisabled] = useState(true);
  const [observacionDisabled, setObservacionDisabled] = useState(true);
  const [guardarDisabled, setGuardarDisabled] = useState(false);

  const initialForm = {
    idJustificacion: justificacion?.idJustificacion,
    area: "",
    estado: "",
    idEvaluacion: justificacion?.idEvaluacion,
    idOrdenPedido: justificacion?.idOrdenPedido,
    idJustificado: 0,
    observacion: ""
  };

  const [motivos, setMotivos] = useState([]);
  const [permisoMedico, setPermisoMedico] = useState(false);
  const [permisoComercial, setPermisoComercial] = useState(false);
  const [permisoBUM, setPermisoBUM] = useState(false);
  const [formData, setFormData] = useState(initialForm);

  useEffect(() => {
    setChildrenAction(() =>
    <div style={{ display: 'flex' }}>
                    <CustomButton
        onClick={() => navigate(-1)}
        style={{ marginRight: 10 }}
        variant={'outlined'}>
        
                        Cancelar
                    </CustomButton>
                    <CustomButton
        loading={updateLoading}
        disabled={guardarDisabled}
        onClick={() => handleGuardar()}
        variant={'contained'}>
        
                        Guardar
                    </CustomButton>
            </div>
    );
  }, [setChildrenAction, formData]);

  useEffect(() => {
    getPermisos();
  }, []);

  const [getPermisoAppME, { data: dataPermisoAppME }] = useLazyQuery(GET_APP_PERMISSION_BY_NOMBRE, {
    fetchPolicy: 'cache-and-network'
  });

  const [getPermisoAppCO, { data: dataPermisoAppCO }] = useLazyQuery(GET_APP_PERMISSION_BY_NOMBRE, {
    fetchPolicy: 'cache-and-network'
  });

  const [getPermisoAppBUM, { data: dataPermisoBum }] = useLazyQuery(GET_APP_PERMISSION_BY_NOMBRE, {
    fetchPolicy: 'cache-and-network'
  });

  useEffect(() => {    
    if (!dataPermisoAppME) return;
    if (dataPermisoAppME.permisoAppByNombre.success) {
      let resultado = dataPermisoAppME.permisoAppByNombre.valorEsperado;
      setPermisoMedico(resultado);
    };
  }, [dataPermisoAppME]);

  useEffect(() => {
    if (!dataPermisoAppCO) return;
    if (dataPermisoAppCO.permisoAppByNombre.success) {
      let resultado = dataPermisoAppCO.permisoAppByNombre.valorEsperado;
      setPermisoComercial(resultado);
    };
  }, [dataPermisoAppCO]);

  useEffect(() => {
    if (!dataPermisoBum) return;
    if (dataPermisoBum.permisoAppByNombre.success) {
      let resultado = dataPermisoBum.permisoAppByNombre.valorEsperado;
      setPermisoBUM(resultado);
    };
  }, [dataPermisoBum]);

  const getPermisos = async () => {
    const justificacionMedico = 'Justificacion Bloqueo Medico';
    const justificacionComercial = 'Justificacion Bloqueo Comercial';
    const justificacionBUM = 'Justificacion Bloqueo BUM';

    let resultadoME = getPermisoAppME({ variables: { nombreApp: justificacionMedico, escritura: true } });
    let resultadoCO = getPermisoAppCO({ variables: { nombreApp: justificacionComercial, escritura: true } });
    let resultadoBUM = getPermisoAppBUM({ variables: { nombreApp: justificacionBUM, escritura: true } });

    let permisoME = resultadoME?.data?.permisoAppByNombre?.valorEsperado;
    let permisoCO = resultadoCO?.data?.permisoAppByNombre?.valorEsperado;

    if (permisoME && permisoCO) {
      setSelectAreaDisabled(false);
    } else if (permisoME) {
      setFormData((previousData) => ({
        ...previousData,
        area: "ME"
      }));
    } else if (permisoCO) {
      setFormData((previousData) => ({
        ...previousData,
        area: "CO"
      }));
    } else {
      setSelectAreaDisabled(false);
    }
  };

  const [getJustificacionMotivo, { data: dataJustificacionMotivo, loading: motivoLoading }] = useLazyQuery(GET_JUSTIFICACION_MOTIVO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataJustificacionMotivo) return;
    setMotivos(dataJustificacionMotivo?.justificacionMotivo);
  }, [dataJustificacionMotivo]);

 useEffect(() => {
  // Configuración por área
  const areaConfig = {
    ME: {
      codigoEstado: justificacion.codigoEstadoMedico,
      observacion: justificacion.obsMedico,
      permiso: permisoMedico
    },
    CO: {
      codigoEstado: justificacion.codigoEstadoComercial,
      observacion: justificacion.obsComercial,
      permiso: permisoComercial
    },
    BUM: {
      codigoEstado: justificacion.codigoEstadoBUM,
      observacion: justificacion.obsBUM,
      permiso: true // BUM no valida permiso
    }
  };

  const config = areaConfig[formData.area];
  
  if (config) {
    const esPendiente = config.codigoEstado === "PE" || config.codigoEstado === "";

    if (esPendiente) {
      setFormData((previousData) => ({
        ...previousData,
        estado: '',
        idJustificado: 0,
        observacion: ''
      }));
      deshabilitarControler(false);
      
      if (!config.permiso) {
        setGuardarDisabled(true);
      }
    } else {
      setFormData((previousData) => ({
        ...previousData,
        estado: config.codigoEstado,
        observacion: config.observacion
      }));
      deshabilitarControler(true);
    }
  }

  getMotivos();
}, [formData.area]);

  const deshabilitarControler = (value) => {
    setSelectEstadoDisabled(value);
    setSelectJustificacionDisabled(value);
    setObservacionDisabled(value);
    setGuardarDisabled(value);
  };

  useEffect(() => {
    getMotivos();
  }, [formData.estado]);

  const handleChange = (e) => {
    const { value, name } = e.target;
    setFormData((previousData) => ({
      ...previousData,
      [name]: value
    }));
  };


  const getMotivos = async () => {
    let motivos = getJustificacionMotivo({ variables: { area: formData.area,
        estado: formData.estado
      }
    });

    if (formData.area == "ME") {
      setFormData((previousData) => ({
        ...previousData,
        idJustificado: justificacion?.justificadoMedico
      }));
    }
    if (formData.area == "CO") {
      setFormData((previousData) => ({
        ...previousData,
        idJustificado: justificacion?.justificadoComercial
      }));
    }
    if (formData.area == "BUM") {
      setFormData((previousData) => ({
        ...previousData,
        idJustificado: justificacion?.justificadoBUM
      }));
    }
  };


  const [updateJustificacion, { data: dataUpdateJustificacion, loading: updateLoading }] = useMutation(UPDATE_JUSTIFICACION_CONDICIONAL);

  useEffect(() => {
    if (!dataUpdateJustificacion) return;
    if (dataUpdateJustificacion?.updateJustificacion) {
      toast.success("Se guardaron los cambios correctamente.");
      setTimeout(() => navigate('/adminBloqueo'), 1000);
    } else {
      toast.error("Se produjo un error al eliminar el proceso");
    }
  }, [dataUpdateJustificacion]);

  const isFormValid = () => {
    if (formData.area === "") {
      toast.error('Debe ingresar el Area.');
      return false;
    }
    if (formData.estado === "") {
      toast.error('Debe ingresar el Estado.');
      return false;
    }
    if (formData.idJustificado <= 0) {
      toast.error('Debe ingresar una Justificacion.');
      return false;
    }
    if (formData.observacion.length <= 0 && formData.area != "BUM") {
      toast.error('Debe ingresar una Observacion.');
      return false;
    }
    return true;
  };

  const handleGuardar = () => {
    if (isFormValid()) {
      updateJustificacion({ variables: {
          idJustificacion: formData.idJustificacion,
          area: formData.area,
          estado: formData.estado,
          idJustificado: formData.idJustificado,
          observacion: formData.observacion
        } });
    }
  };

  return (
    <>
            <div>
                <Grid
          container
          spacing={2}
          sx={{ marginBottom: '25px' }}>
                                 
 <Grid size={{ md: 2 }}>
                            <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size="small">
                                <InputLabel id="select-area">Area</InputLabel>
                                <Select
                labelId="select-area"
                label='Area'
                onChange={handleChange}
                value={formData?.area}
                disabled={selectAreaDisabled}
                name='area'>
                
                                    {(permisoComercial || permisoBUM) &&
                <MenuItem value="CO">Comercial</MenuItem>
                }
                                    {(permisoMedico || permisoBUM) &&
                <MenuItem value="ME">Medico</MenuItem>
                }
                                    {permisoBUM &&
                <MenuItem value="BUM">BUM</MenuItem>
                }
                                </Select>
                            </FormControl>
                        </Grid> 
 <Grid size={{ md: 2 }}> 
                            <TextField
              disabled={true}
              label="Número Pedido"
              size="small"
              type="text"
              variant="outlined"
              name="idOrdenPedido"
              value={formData?.idOrdenPedido}
              sx={{ backgroundColor: 'white' }} />
            
                        </Grid>
 <Grid size={{ md: 2 }}> 
                            <TextField
              disabled={true}
              label="Número Contrato"
              size="small"
              type="text"
              variant="outlined"
              name="idEvaluacion"
              value={formData?.idEvaluacion}
              sx={{ backgroundColor: 'white' }} />
            
                        </Grid>
 <Grid size={{ md: 2 }}>
                            <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size="small">
                                <InputLabel id="select-estado">Estado</InputLabel>
                                <Select
                labelId="select-estado"
                label='Estado'
                onChange={handleChange}
                value={formData?.estado}
                disabled={selectEstadoDisabled}
                name='estado'>
                
                                    <MenuItem value="AP">Aprobado</MenuItem>
                                    <MenuItem value="RE">Rechazado</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid> 
 <Grid size={{ md: 4 }}>
                            <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size="small">
                                <InputLabel id="select-idJustificado">Justificación</InputLabel>
                                <Select
                labelId="select-idJustificado"
                label='Justificación'
                onChange={handleChange}
                value={formData?.idJustificado}
                disabled={selectJustificacionDisabled}
                name='idJustificado'>
                
                                    {motivos && motivos.map((motivo) => {
                  return <MenuItem key={motivo.idMotivoJustificacion} value={motivo.idMotivoJustificacion}> {motivo.descripcionLarga} </MenuItem>;
                })}
                                </Select>
                            </FormControl>
                        </Grid>   
 <Grid size={{ xs: 12 }}>
                            <TextInput
              label='Observaciones'
              placeholder='Observaciones'
              name='observacion'
              value={formData?.observacion}
              onChange={handleChange}
              disabled={observacionDisabled}
              multiline={true}
              rows={4} />
            
                        </Grid>                                      
                </Grid>
            </div>
        </>);

};